export default function isMaskedPhoneInputValid(
  phone?: string,
): phone is string {
  // We do simple phone number validation by removing all non-numeric characters from the phone number
  // and verifying that its length matches the US phone length of 10
  const phoneLength = phone && phone.replace(/[\D]/g, '').length;

  return phoneLength === 10 || phoneLength === 11;
}
